import { useMemo } from 'react'
import { aiGeneratedNeedsReview } from '../aiReviewUtils'

export const useAiReviewNeeded = (test) => {
  const { isReviewRequired, itemGroups } = test || {}
  return useMemo(
    () => isReviewRequired || aiGeneratedNeedsReview(itemGroups || []),
    [isReviewRequired, itemGroups]
  )
}
